import * as actionTypes from './action-types';

const initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: [],
    filteredCourses: []
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actionTypes.GET_YEAR_GROUP_SUCCESS: {
        return { ...state, yearGroups: action.data };
    }
    case actionTypes.GET_COUNTRY_SUCCESS: {
        return { ...state, countries: action.data };
    }

    case actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST: {
        return { ...state, isLoadingCountryYearGroups: true };
    }
    case actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS: {
        return { ...state,
            isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
            yearGroups: action.yearGroups };
    }
    case actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE: {
        return { ...state, isLoadingCountryYearGroups: action.isLoadingCountryYearGroups };
    }

    case actionTypes.GET_PRODUCT_COURSE_REQUEST:
    case actionTypes.GET_SCHOOL_COURSE_REQUEST: {
        return { ...state,
            isProductCoursesLoaded: false,
            productCourses: [],
            filteredCourses: []
        };
    }

    case actionTypes.GET_PRODUCT_COURSE_SUCCESS:
    case actionTypes.GET_SCHOOL_COURSE_SUCCESS: {
        return { ...state,
            isProductCoursesLoaded: true,
            productCourses: action.data,
            filteredCourses: action.data
        };
    }

    case actionTypes.GET_FILTERED_UPF_COURSES_SUCCESS: {
        return { ...state,
            isProductCoursesLoaded: true,
            filteredCourses: action.data
        };
    }

    case actionTypes.GET_PRODUCT_COURSE_FAILURE:
    case actionTypes.GET_SCHOOL_COURSE_FAILURE:
    case actionTypes.GET_FILTERED_UPF_COURSES_FAILURE: {
        return { ...state,
            isProductCoursesLoaded: true,
            productCourses: [],
            filteredCourses: []
        };
    }
    case actionTypes.CLEAR_COURSE_LIST: {
        return { ...state, productCourses: action.productCourses };
    }

    case actionTypes.DESELECT_COURSE: {
        return { ...state, deselectCourse: action.deselectCourse };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/assign-courses-upf/reducer.js